<template>
  <div class="user-card is-relative">
    <div class="user-card__picture">
      <img :src="picture" :alt="`Foto de perfil del investigador ${name}`" />
    </div>
    <div class="user-card__info">
      <h3 class="user-card__name">
        <router-link :to="`/profile/${researcherId}`" class="mock">{{
          name
        }}</router-link>
      </h3>
      <p class="user-card__title">{{ title }}</p>
      <List horizontal class="user-card__social">
        <li class="orcid">
          <a href="">
            <img
              src="https://repositorio.igp.gob.pe/themes/Mirage/images/orcid.png"
            />
          </a>
        </li>
        <li class="ctivitae">
          <a href="">
            <img
              src="https://repositorio.igp.gob.pe/themes/Mirage/images/ctivitae.png"
            />
          </a>
        </li>
        <li class="ctivitae">
          <a href="">
            <img
              src="https://repositorio.igp.gob.pe/themes/Mirage/images/scopus.png"
            />
          </a>
        </li>
      </List>
    </div>
  </div>
</template>
<script>
import List from "./List.vue";
export default {
  components: {
    List
  },
  props: {
    picture: {
      type: String,
      default:
        "https://prd-wret.s3.us-west-2.amazonaws.com/assets/palladium/production/s3fs-public/styles/atom_page_medium/public/thumbnails/image/Placeholder_person.png"
    },
    name: {
      type: String,
      default: "No Name"
    },
    title: {
      type: String,
      default: "No Title"
    },
    orcID: {
      type: String,
      default: () => ""
    },
    ctivitaeID: {
      type: String,
      default: () => ""
    },
    researcherId: {
      type: String
    }
  },
  setup() {}
};
</script>
<style lang="scss" scoped>
@use "@/assets/styles/tools/_mixins.scss";
@use "@/assets/styles/settings/_variables.scss";
.user-card {
  background-color: variables.$background-lighter-color;
  padding-bottom: 3em;
  padding-top: 2em;
  margin-bottom: 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:hover {
    .user-card__picture img {
      transition: all 0.3s;
      transform: scale(1.03);
    }
    .user-card__name a {
      color: variables.$primary-color;
    }
  }
  &__picture {
    margin-bottom: 1rem;
    max-width: 250px;
    img {
      border-radius: 50%;
      transition: transform 0.2s;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__name {
    font-size: 20px;
    text-transform: uppercase;
    a {
      color: currentColor;
      text-decoration: none;
    }
  }
  &__social > li {
    margin-right: 0.75rem;
    img {
      height: 30px;
      //filter: sepia(100%) hue-rotate(170deg) saturate(200%);
      filter: grayscale(1);
      transform: translateY(0);
      transition: transform 0.2s;
    }
    &:hover img {
      filter: none;
      transform: translateY(-5px);
    }
  }
}
</style>
